import { Component, OnInit } from "@angular/core";
import { finalize } from "rxjs/operators";

import { AuthService } from "src/app/_app-core/services/auth/auth.service";
import { environment } from "src/environments/environment";

/**
 * Builds the admin app URL for hash route #/return with exitImpersonation so the
 * admin SPA can restore the saved login snapshot. Strips any existing hash from config.
 */
function buildAdminExitImpersonationUrl(adminConfig: string): string {
  const withoutHash = adminConfig.trim().split("#")[0].replace(/\/$/, "");
  return `${withoutHash}/#/return?exitImpersonation=true`;
}

@Component({
  selector: "app-exit-impersonation",
  templateUrl: "./exit-impersonation.component.html",
  styleUrls: ["./exit-impersonation.component.scss"],
})
export class ExitImpersonationComponent implements OnInit {
  constructor(private authService: AuthService) {}

  ngOnInit(): void {
    const userData = {
      session: { sessionId: localStorage.getItem("eippSession") },
    };

    this.authService
      .logOut(userData)
      .pipe(finalize(() => this.redirectToAdminReturn()))
      .subscribe(
        (res) => {
          const responseData: any = res;
          if (responseData.status === "ok") {
            localStorage.clear();
          }
        },
        (error) => {
          console.error(error);
        }
      );
  }

  private redirectToAdminReturn(): void {
    window.location.href = buildAdminExitImpersonationUrl(environment.admin);
  }
}
